import React, { useState } from 'react';
import { motion } from 'framer-motion';
const CHECKOUT_URL_MEGAPACK = 'https://docentes2.edulabs.online/cart/43273417097334:1';
const CHECKOUT_URL_MEGAPACK_KIT = 'https://docentes2.edulabs.online/cart/43273433809014:1';
export function PricingSelector() {
  const [selectedOption, setSelectedOption] = useState<1 | 2>(2);
  const handleCheckout = () => {
    const url = selectedOption === 1 ? CHECKOUT_URL_MEGAPACK : CHECKOUT_URL_MEGAPACK_KIT;
    window.open(url, '_blank');
  };
  return <div className="max-w-2xl mx-auto w-full flex flex-col space-y-4" data-id="element-195">
      {/* Option 1 */}
      <div onClick={() => setSelectedOption(1)} className={`cursor-pointer rounded-2xl p-6 transition-all border-2 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 ${selectedOption === 1 ? 'bg-dark-card border-brand-DEFAULT shadow-[0_0_20px_rgba(255,107,0,0.1)]' : 'bg-dark-card border-[#333340] hover:border-dark-border'}`} data-id="element-196">
        <div className="flex items-start space-x-4" data-id="element-197">
          <div className="mt-1 flex-shrink-0" data-id="element-198">
            {selectedOption === 1 ? <div className="w-6 h-6 rounded-full border-2 border-brand-DEFAULT flex items-center justify-center" data-id="element-199">
                <div className="w-3 h-3 rounded-full bg-brand-DEFAULT" data-id="element-200"></div>
              </div> : <div className="w-6 h-6 rounded-full border-2 border-[#333340]" data-id="element-201"></div>}
          </div>
          <div data-id="element-202">
            <div className="flex items-center space-x-2 mb-1" data-id="element-203">
              <span className="text-xl" data-id="element-204">📘</span>
              <h3 className="text-white font-bold text-lg" data-id="element-205">
                MEGAPACK VOLEY LISTO
              </h3>
            </div>
            <p className="text-text-secondary text-sm" data-id="element-206">6 tomos + 6 bonos</p>
          </div>
        </div>
        <div className="flex flex-col items-end flex-shrink-0 ml-10 md:ml-0" data-id="element-207">
          <span className="text-text-secondary line-through text-sm" data-id="element-208">
            USD 24,90
          </span>
          <span className="text-white font-bebas text-3xl" data-id="element-209">USD 13,90</span>
        </div>
      </div>

      {/* Option 2 */}
      <div onClick={() => setSelectedOption(2)} className={`cursor-pointer rounded-2xl p-6 transition-all border-2 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 ${selectedOption === 2 ? 'bg-dark-card border-brand-DEFAULT shadow-[0_0_30px_rgba(255,107,0,0.15)]' : 'bg-dark-card border-[#333340] hover:border-dark-border'}`} data-id="element-210">
        <div className="flex items-start space-x-4" data-id="element-211">
          <div className="mt-1 flex-shrink-0" data-id="element-212">
            {selectedOption === 2 ? <div className="w-6 h-6 rounded-full border-2 border-brand-DEFAULT flex items-center justify-center" data-id="element-213">
                <div className="w-3 h-3 rounded-full bg-brand-DEFAULT" data-id="element-214"></div>
              </div> : <div className="w-6 h-6 rounded-full border-2 border-[#333340]" data-id="element-215"></div>}
          </div>
          <div data-id="element-216">
            <div className="flex flex-wrap gap-2 mb-2" data-id="element-217">
              <span className="bg-brand-gold text-dark-DEFAULT text-xs font-bold px-2 py-0.5 rounded-full flex items-center" data-id="element-218">
                ⭐ MÁS ELEGIDO
              </span>
              <span className="bg-dark-border text-brand-DEFAULT text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-219">
                AHORRAS USD 12
              </span>
            </div>
            <div className="flex items-center space-x-2 mb-1" data-id="element-220">
              <span className="text-xl" data-id="element-221">🏆</span>
              <h3 className="text-white font-bold text-lg" data-id="element-222">
                MEGAPACK + KIT TÁCTICO PRO
              </h3>
            </div>
            <p className="text-text-secondary text-sm max-w-sm" data-id="element-223">
              6 tomos + 6 bonos + Kit Táctico Pro™ (pizarras, señales, scouting
              y gestión de competencia)
            </p>
          </div>
        </div>
        <div className="flex flex-col items-end flex-shrink-0 ml-10 md:ml-0" data-id="element-224">
          <span className="text-text-secondary line-through text-sm" data-id="element-225">
            USD 31,90
          </span>
          <span className="text-white font-bebas text-4xl" data-id="element-226">USD 19,90</span>
        </div>
      </div>

      {/* CTA Button */}
      <div className="pt-4" data-id="element-227">
        <motion.button onClick={handleCheckout} whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="w-full bg-brand-DEFAULT hover:bg-brand-hover text-white font-bebas text-2xl px-6 py-4 rounded-xl uppercase tracking-wide shadow-[0_0_20px_rgba(255,107,0,0.3)] transition-all" data-id="element-228">
          {selectedOption === 1 ? '→ QUIERO MI MEGAPACK' : '→ SÍ, QUIERO EL MEGAPACK + KIT TÁCTICO PRO'}
        </motion.button>
        <p className="text-center text-sm text-text-secondary mt-4" data-id="element-229">
          La más elegida por entrenadores que quieren profesionalizarse y ganar
          más partidos.
        </p>
      </div>
    </div>;
}